import { ChangeDetectorRef, Component, inject, Input, OnDestroy } from '@angular/core';
import { Entity } from 'globals/store/entity.data';
import { CreateTaskData, TaskViewService } from './../../services/task.view.service';
import { Wrapper } from 'src/app/components/wrapper.component';
import { ActionButtonComponent } from 'src/app/components/nav-bar/action-button.component';
import { TasksTableComponent } from 'src/app/components/home/tasks-table.component';

@Component({
    selector: 'entity-tasks',
    template: `
<div class="tasks-menu">
  <h3>Tasks associated with {{ entity.name }}</h3>
  <div style="flex:1;"></div>
  <action-button id="addTaskButton" [text]="'+ ADD A TASK'" (click)="addEntityTask()"></action-button>
</div>
<tasks-table 
  [entityId]="entity.id"
  [otherChangeDetectorRef]="changeDetectorRef"
  [isNestedDialog]="true"
></tasks-table>
`,
    styleUrls: ['entity-tasks.scss'],
    standalone: true,
    imports: [ActionButtonComponent, TasksTableComponent],
})
export class EntityTasksComponent extends Wrapper<EntityTasksComponent> implements OnDestroy {
  @Input() entity: Entity
  @Input() changeDetectorRef: ChangeDetectorRef
  private taskViewService: TaskViewService = inject(TaskViewService)

  constructor() {
    super()
  }
  
  async addEntityTask() {
    const rect = document.getElementById('addTaskButton').getBoundingClientRect()
    const data: CreateTaskData = { eventId: this.eventService.eventId, dialog: this.dialog, rect, entityId: this.entity.id }
    this.changeDetectorRef.detach()
    await this.taskViewService.addTaskThroughPopupDialog(data)
    this.changeDetectorRef.reattach()
  }
}



